export const setCompanyDetails = (companyDetails, global_var, setCompanyName, setFavicon) => {
  if (companyDetails) {
    // Set global variables
    global_var.companyId = companyDetails.companyId;
    global_var.company_name = companyDetails.companyName;
    global_var.domain_name = window.location.hostname;

    // Set parent company ID if available
    if (companyDetails.parentCompanyId) {
      global_var.parentCompanyId = companyDetails.parentCompanyId;
    }

    // Set dashboard URL if available
    if (companyDetails.dashboardUrl) {
      global_var.dashboard_url = companyDetails.dashboardUrl;
    }

    // Set and update logo URL if available
    if (companyDetails.appSettings.logo) {
      const redirectionUrl = 'https://services.baabtra.com/files/';
      const s3FileUploadUrl = 'https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/';

      // Replace the redirection URL with the S3 file upload URL if necessary
      if (companyDetails.appSettings.logo.includes(redirectionUrl)) {
        companyDetails.appSettings.logo = companyDetails.appSettings.logo.replace(redirectionUrl, s3FileUploadUrl);
      }

      global_var.logo = companyDetails.appSettings.logo;
    }

    // Set favicon if available
    if (companyDetails.appSettings.favicon) {
      setFavicon(companyDetails.appSettings.favicon);
    } else if (global_var.logo) {
      setFavicon(global_var.logo);
    }

    // Set the company name in the state
    setCompanyName(global_var.company_name);
  }
};
